import { render, staticRenderFns } from "./CardBuildSubMenu.vue?vue&type=template&id=298b0928&scoped=true"
import script from "./CardBuildSubMenu.vue?vue&type=script&lang=js"
export * from "./CardBuildSubMenu.vue?vue&type=script&lang=js"
import style0 from "./CardBuildSubMenu.vue?vue&type=style&index=0&id=298b0928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b0928",
  null
  
)

export default component.exports